import jwt from 'jwt-decode';
export const userRole = () => {
  const token = localStorage.getItem('token');
  const persistedToken = !!token && jwt(token);
  return !!persistedToken && persistedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
};

export const integerRegex = new RegExp('^[0-9]+$');
export const positiveIntegerRegex = new RegExp('^[0-9]+[.]?[0-9]+$|^[0-9]{1}$|^[0-9]+[.]$');
export const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//prettier-ignore
export const newEmailRegex = /^\w.+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/
export const letterRegex = new RegExp('^[А-Яа-я|ёЁәӘқҚңҢІіҒғҰұөӨһҺүҮ|]+$');
export const schoolYearRegex = new RegExp('^([1-9]|1[0-2])$');
export const latinRegex = new RegExp('^[A-Za-z|[0-9]+$');
export const loginRegex = new RegExp('^[A-Za-z0-9]+(?:[. _-][A-Za-z0-9]+)*$');
export const studyYearRegex = new RegExp('^[0-9]{1,2}/[0-9]{1,2}$');
export const phoneRegex = /^(\+\d{1}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{2}?[\s.-]?\d{2}$/;

export const subjectsRegex = (studyYearFrom, studyYearTo) => {
  if (studyYearTo > 9 && studyYearFrom > 9) {
    return new RegExp(`^1[0-${studyYearTo % 10}]?$`);
  }
  if (studyYearFrom > 9 && studyYearTo > 9) {
    return new RegExp(`^1[0-${studyYearFrom % 10}]?$`);
  }
  if (studyYearTo < 10 && studyYearFrom < 10) {
    return new RegExp(`^[${studyYearFrom}-${studyYearTo}]?$`);
  }
  if (studyYearFrom < 10 && studyYearTo > 9) {
    return new RegExp(`^([${studyYearFrom}-9]|1[0-${studyYearTo % 10}])$`);
  }

};
export const timeFormat = 'HH:mm';
export const dateFormat = 'DD/MM/YYYY';

export const maxIntegerLengthRegex = (number) => {
  const variantsCount = String(number).split('');
  var regex = '';
  for (let i = 1; i < variantsCount.length + 1; i++) {
    if (i !== variantsCount.length) {
      for (let j = 0; j < i; j++) {
        regex += `[0-9]`;
      }
      regex += '|';
    } else {
      for (let j = 0; j < i; j++) {
        regex += `[0-${variantsCount[j]}]`
      }
    }
  }
  return new RegExp(`^(${regex})$`);
}